export let DerivedErrorTypes = /*#__PURE__*/function (DerivedErrorTypes) {
  DerivedErrorTypes["EXACT_CHARACTER_LENGTH_ERROR"] = "EXACT_CHARACTER_LENGTH_ERROR";
  DerivedErrorTypes["CHARACTER_LENGTH_RANGE_ERROR"] = "CHARACTER_LENGTH_RANGE_ERROR";
  DerivedErrorTypes["VALUE_RANGE_ERROR"] = "VALUE_RANGE_ERROR";
  DerivedErrorTypes["EXACT_ITEMS_NUMBER_ERROR"] = "EXACT_ITEMS_NUMBER_ERROR";
  DerivedErrorTypes["DECIMAL_POINT_ERROR"] = "DECIMAL_POINT_ERROR";
  DerivedErrorTypes["INCOMPLETE_DATE_ERROR"] = "INCOMPLETE_DATE_ERROR";
  return DerivedErrorTypes;
}({});
//# sourceMappingURL=error-types.js.map